class DropdownList {
  /**
   * @param {HTMLElement} element - the dropdown list element
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        backButton: ".js-DropdownList-back",
        label: ".js-DropdownList-label",
      },
      classes: {
        active: "is-active",
      },
    };

    this.items = [...element.querySelectorAll(this.config.selectors.label)];
    this._bind();
  }

  /**
   * bind
   */
  _bind() {
    this.items.forEach((item) => {
      item.addEventListener("click", () => {
        const activeItem = this.items.find((i) =>
          i.classList.contains(this.config.classes.active)
        );
        this._bindBackButton(item);
        if (activeItem && activeItem !== item) {
          activeItem.classList.remove(this.config.classes.active);
        }
        this._toggleActiveClass(item);
      });
    });
  }

  /**
   * binds click event listener to backButton and stores state in data attribute
   *
   * @param {HTMLElement} item
   * @private
   */
  _bindBackButton(item) {
    const backButton = item.parentElement.querySelector(
      this.config.selectors.backButton
    );

    if (!backButton.dataset.initialized) {
      backButton.addEventListener("click", () => {
        item.classList.remove(this.config.classes.active);
      });

      backButton.dataset.initialized = true;
    }
  }

  /**
   * adds activeClass to the element when its has been clicked
   *
   * @param {HTMLElement} currentElement
   * @private
   */
  _toggleActiveClass(currentElement) {
    currentElement.classList.toggle(this.config.classes.active);
  }
}

export default DropdownList;
